import { Text } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/SidebarHeading.tsx
const SidebarHeading = ({ children, "data-testid": testId }) => /* @__PURE__ */ jsx(Text, {
	size: "lg",
	fw: 600,
	style: { color: `var(--mantine-color-gray-4)` },
	"data-testid": testId,
	children
});

//#endregion
export { SidebarHeading };